import { ToastType } from '.'
import { type LoginIframeExchangeData } from '../login/loginIframeExchangeData'
import { nanoid } from 'nanoid'
import { writable } from 'svelte/store'

export interface ToastMessage {
	id?: string
	title: string
	text?: string
	html?: string
	type: ToastType
	icon?: string
}

export function createToasts() {
	const { subscribe, update } = writable<ToastMessage[]>([])

	const toastVisibleTime = 10000

	function removeToast(id: string): void {
		update((toasts) => toasts.filter((toast) => toast.id !== id))
	}

	return {
		subscribe,
		add: (toast: ToastMessage) => {
			if (window.top === window.self) {
				const id = nanoid()
				update((toasts) => [{ ...toast, id }, ...toasts])
				// remove after some time
				setTimeout(() => removeToast(id), toastVisibleTime)
			} else {
				const postMessage: LoginIframeExchangeData = { toast }
				window.parent.postMessage(postMessage, { targetOrigin: '*' })
			}
		},
		remove: (id: string) => {
			removeToast(id)
		},
	}
}

export const toasts = createToasts()
